import IconDownload from '@creditflowresearch/uilib/Icon/IconDownload';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import { useAskAiChatContext } from '@/creditflowresearch/application/AskAiChat/context/AskAiChatContext';
import { AskAiProduct } from '@/creditflowresearch/domain/vo/AskAiChat';
import styles from './askAiChat.module.scss';

interface IInlineExportButtonProps {
  messageId: string,
  product: AskAiProduct,
}

const InlineExportButton = ({ messageId, product }: IInlineExportButtonProps) => {
  const { exportData, isExporting } = useAskAiChatContext();
  const isLoading = isExporting(messageId, product);

  return (
    <button
      type="button"
      className={ styles.inlineExportButton }
      onClick={ () => exportData(messageId, product) }
      disabled={ isLoading }
      aria-label="Download the Excel file"
      data-test="askAiChatInlineExport"
    >
      { isLoading ? <Spinner size="XS" color="currentColor" /> : <IconDownload size={ 12 } /> }
    </button>
  );
};

export default InlineExportButton;
